import React, { useState, useEffect } from "react";

const Distancia = ({ rpm = 0 }) => {
  const [distancia, setDistancia] = useState(0);

  useEffect(() => {
    const factor = 0.003; // km por pedalada (~3 metros)
    let intervalo;

    if (rpm > 0) {
      intervalo = setInterval(() => {
        const pedaladasPorSegundo = rpm / 60;
        const kmPorSegundo = pedaladasPorSegundo * factor;

        setDistancia((prev) => {
          const nueva = prev + kmPorSegundo;
          return parseFloat(nueva.toFixed(5)); // 🔹 evita errores acumulativos
        });
      }, 1000);
    }

    return () => clearInterval(intervalo);
  }, [rpm]);

  return (
    <div
      id="distancia-recorrida"
      data-valor={distancia}
      className="text-xl font-bold mt-2"
    >
      {distancia.toFixed(2)} Km
    </div>
  );
};

export default Distancia;
